import { DateInput } from "@/modules/common/components";

import { FilterFieldRendererProps } from "../types";

const DateFilterField = ({ field, value, onChange }: FilterFieldRendererProps<string>) => {
  return <DateInput placeholder={field.label} value={value ?? ""} onChange={(next) => onChange(next || undefined)} />;
};

export default DateFilterField;
